export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6856.74ff3e04.jpg";